import { useTranslation } from 'react-i18next'

interface AddressInputProps {
  address?: string
  show?: boolean
  onChange: (value: string) => void
}

export const AddressInput = ({ address, onChange, show = true }: AddressInputProps) => {
  if (!show) {
    return null
  }
  const { t } = useTranslation()

  return (
    <div className="address">
      <div className="label">{t('wallet.withdrawView.yourAddress', 'Your address')}</div>
      <input type="text" className="value" onChange={(e) => onChange(e.target.value)} value={address} />
    </div>
  )
}

export default AddressInput
